// Remove by https://app.clickup.com/t/86c0kfr9m and use `newStyles.ts` instead
// TEMP solution!

import { getThemeData } from '@src/theming';

import { fontThemeStyle as newFontThemeStyle } from './newTheme';
import { fontThemeStyle as oldFontThemeStyle } from './oldTheme';

export const fontThemeStyle = new Proxy(newFontThemeStyle, {
  get: (_, prop: string) => {
    try {
      const { isNewThemeActive } = getThemeData();

      if (
        isNewThemeActive &&
        newFontThemeStyle[prop as keyof typeof newFontThemeStyle]
      ) {
        return newFontThemeStyle[prop as keyof typeof newFontThemeStyle];
      }

      return oldFontThemeStyle[prop as keyof typeof oldFontThemeStyle] ?? '';
    } catch (e) {
      console.error(e);
      return oldFontThemeStyle[prop as keyof typeof oldFontThemeStyle] ?? '';
    }
  },
});
